import React, { useState, useMemo } from "react";
import { Box, Stack } from '@mui/material';

const HistoryPoiJsonToTable = ({ data, map }) => {
    const features = data || [];

    const polygonFeatures = useMemo(
        () => features.filter((f) => f.geometry?.type === "Polygon"),
        [features]
    );

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    const totalPages = Math.ceil(polygonFeatures.length / pageSize);

    const currentPageFeatures = useMemo(() => {
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        return polygonFeatures.slice(start, end);
    }, [polygonFeatures, page, pageSize]);

    const allKeys = Array.from(
        new Set(
            currentPageFeatures.flatMap((f) =>
                f.properties ? Object.keys(f.properties) : []
            )
        )
    );

    const handleRowClick = (geometry) => {
        if (geometry.type !== "Polygon") return;
        const bounds = geometry.coordinates[0].map((v) => [v[1], v[0]]);
        map.flyToBounds(bounds, { duration: 1 });
    };

    const handlePrev = () => setPage((p) => Math.max(p - 1, 1));
    const handleNext = () => setPage((p) => Math.min(p + 1, totalPages));

    return (
        <div>
            <div style={{ minHeight: "calc(100vh - 300px)", maxHeight: "calc(100vh - 300px)", overflow: "auto", paddingLeft: "5px", paddingRight: "5px" }}>
                <table
                    className="json-to-table"
                    border="1"
                    cellPadding="5"
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "left",
                    }}
                >
                    <thead>
                        <tr>
                            {allKeys.map((key) => (
                                <th key={key}>{key}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageFeatures.map((f, i) => {
                            const props = f.properties || {};
                            return (
                                <tr
                                    key={i}
                                    onClick={() => handleRowClick(f.geometry)}
                                    style={{
                                        cursor: "pointer",
                                        backgroundColor:
                                            i % 2 === 0 ? "#f9f9f9" : "white",
                                    }}
                                >
                                    {allKeys.map((key) => (
                                        <td key={key}>
                                            {props[key] !== undefined
                                                ? String(props[key])
                                                : "-"}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <Box sx={{ paddingX: "10px" }}>
                <Stack direction="row" justifyContent="space-between" spacing={1}>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                        }}
                    >
                        <button onClick={handlePrev} disabled={page === 1}>
                            {/* Prev */}
                            {`<`}
                        </button>
                        <span>
                            {page} / {totalPages || 1}
                            {/* Page {page} / {totalPages || 1} */}
                        </span>
                        <button onClick={handleNext} disabled={page === totalPages || totalPages === 0}>
                            {/* Next */}
                            {`>`}
                        </button>
                    </div>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                        }}
                    >
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            {[20, 50, 80, 100].map(size => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                </Stack>
            </Box>
        </div>
    );
};

export default HistoryPoiJsonToTable;
